import {React, observer} from '@api'
import {CatalogItemSidebarDetailsLoader} from '@lazy'
import {CatalogFilters, CatalogItemsList, CatalogLibraries, LoadingIndicator} from '@modules'
import * as css from './LeftSidebarBody.css'
import {useCatalog} from '@stores'
import {Fragment, useEffect} from 'react'

export const LeftSidebarBody = observer(function LeftSidebarBody() {
  const catalog = useCatalog(),
    {
      hasFinishedFirstLoad,
      stores: {
        sidebar: {
          left,
          left: {
            selectedTab,
            selectedPathItem,
            selectedLibraryConfig,
            associatedWorkspace,
            selectedCatalogFieldLibrary,
            selectedLibrary
          }
        }
      },
      shouldRenderLibraryTab
    } = catalog

  return (
    <div className={css.sidebarBody} data-library-ids={selectedPathItem?.where ? JSON.stringify(selectedPathItem?.where, null, 2) : undefined}
         data-library={selectedLibrary?.id}
         data-catalog-field={selectedCatalogFieldLibrary?.field}
         data-tab={selectedTab}
         style={{'--sidebar-width': `${left.width}px`} as any}
    >
      {!hasFinishedFirstLoad ? <LoadingIndicator/> : <Fragment>
        <CatalogFilters/>
        {shouldRenderLibraryTab &&
		 <Fragment>
			 <CatalogLibraries align='left'/>
			 <CatalogItemsList library={selectedLibrary}
			                   workspace={associatedWorkspace ?? catalog.workspaceConfig}
			                   catalogField={selectedCatalogFieldLibrary}
			                   key={selectedLibrary?.id ?? selectedLibrary?.id}
                         titleStyle='count'
			                   visible={selectedTab === 'libraries' && (selectedLibraryConfig != null || selectedCatalogFieldLibrary) != null}
			                   align='left'/>
           {selectedPathItem?.where && <CatalogItemSidebarDetailsLoader align='left'
		                                                                key={`details-loader-${selectedPathItem.libraryId}`}
		                                                                library={selectedLibraryConfig}
		                                                                where={selectedPathItem?.where}
		                                                                context={selectedPathItem?.sidebarContext}/>}
		 </Fragment>}
      </Fragment>}
    </div>)
})



// WEBPACK FOOTER //
// ./src/modules/catalog/sidebar/LeftSidebar/LeftSidebarBody.tsx